// Central site configuration used for SEO metadata and JSON-LD.
// The real origin comes from the platform environment variable and falls back
// to the canonical production domain.
export const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://cssbuybr.study';

export const SITE_TITLE = 'CSSBuy Spreadsheet';

// Brand logo / icon (authoritative favicon provided for this site).
export const SITE_LOGO =
  'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/d367cf6745ee47f3fc82c76d3a54c50c.png';

// Default social share image (existing hero artwork already used on the site).
export const DEFAULT_OG_IMAGE =
  'https://readdy.ai/api/search-image?query=Vibrant%20fashion%20editorial%20flat%20lay%20with%20colorful%20sneakers%20hoodies%20and%20accessories%20scattered%20on%20a%20warm%20terracotta%20linen%20background%2C%20dramatic%20natural%20light%2C%20modern%20streetwear%20photography%2C%20rich%20warm%20tones%2C%20energetic%20composition&width=1600&height=900&seq=hero-bg-02&orientation=landscape';